import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import logo from "./../../images/logo-crypto 2.png";
import instagramIcon from "./../../images/social1.png";
import youtubeIcon from "./../../images/social2.png";
import linkedinIcon from "./../../images/social4.png";
import twitterIcon from "./../../images/social5.png";

// Condensed from the hero subheadline so both read as the same brand voice.
const BRAND_BLURB =
  "A marketing & fundraising platform for Blockchain, Crypto and Web3 projects. " +
  "We combine media, events and direct access to our community of Investors, " +
  "Mentors & KOLs to accelerate the teams we back.";

const LINK_COLUMNS = [
  {
    heading: "Quick Links",
    links: [
      { label: "View Projects", to: "/user/projects" },
      // { label: "Upload Project", to: "/user/createProject" },
      { label: "View Blogs", to: "/user/blogs" },
      // { label: "Upload Blog", to: "/user/createBlog" },
      { label: "View Events", to: "/user/events" },
      // { label: "Upload Event", to: "/user/createEvent" },
      { label: "Login", to: "/user/login" },
      { label: "Sign Up", to: "/user/join/crypto" },
    ],
  },
  {
    heading: "Learn",
    links: [
      { label: "About", to: "/about" },
      { label: "Why Join", to: "/#whyJoin", hash: true },
      { label: "Podcast", to: "/#podcast", hash: true },
      { label: "Contact Us", to: "/user/contact" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy", to: "/user/privacy/policy" },
      { label: "Terms of use", to: "/user/terms" },
    ],
  },
];

const SOCIALS = [
  {
    label: "Instagram",
    icon: instagramIcon,
    href: "https://www.instagram.com/thecryptohub_com/",
  },
  {
    label: "YouTube",
    icon: youtubeIcon,
    href: "https://www.youtube.com/@thecryptohub_com",
  },
  {
    label: "LinkedIn",
    icon: linkedinIcon,
    href: "https://www.linkedin.com/company/thecryptohubcom",
  },
  {
    label: "X",
    icon: twitterIcon,
    href: "https://twitter.com/thecryptohubcom",
  },
];

const LINK_CLASS =
  "font-body text-[15px] text-[#e5e1e4] no-underline " +
  "hover:text-accent transition-colors duration-200";

const FooterLink = ({ link }) =>
  link.hash ? (
    <HashLink to={link.to} className={LINK_CLASS}>
      {link.label}
    </HashLink>
  ) : (
    <Link to={link.to} className={LINK_CLASS}>
      {link.label}
    </Link>
  );

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // The gradient mirrors the navbar — same two opaque stops, flipped, so the
  // lighter edge sits at the bottom of the page as it does at the top.
  return (
    <footer className="w-full relative overflow-hidden bg-[#010810] border-t border-outline-variant/15">
      {/* `!justify-*` / `!flex-nowrap` throughout: several legacy stylesheets
          redefine a global `.flex` with wrap + space-between and load after
          Tailwind. */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="flex flex-col md:flex-row md:!justify-between gap-14">
          {/* Brand */}
          <div className="flex flex-col !justify-start gap-4 max-w-[380px]">
            <Link to="/" className="w-fit">
              <img src={logo} alt="The Crypto Hub" className="w-[190px]" />
            </Link>

            <p className="font-body text-sm leading-relaxed text-on-surface-variant m-0">
              {BRAND_BLURB}
            </p>

            <div className="flex items-center !justify-start !flex-nowrap gap-3 mt-2">
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="footerSocialLink shrink-0 w-14 h-14 rounded-lg border border-outline-variant/40 flex items-center !justify-center opacity-90 hover:opacity-100 hover:border-accent hover:-translate-y-0.5 transition-all duration-300"
                >
                  <img
                    src={social.icon}
                    alt=""
                    className="footerSocialIcon w-[26px] h-[26px] object-contain"
                  />
                </a>
              ))}
            </div>

            <span className="font-body text-sm text-[#e5e1e4] mt-2">
              © {currentYear} The Crypto Hub. All Rights Reserved.
            </span>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-12 gap-y-10 md:gap-x-20">
            {LINK_COLUMNS.map((column) => (
              <div key={column.heading}>
                <span className="font-headline font-bold text-[17px] text-white pb-3 mb-6 border-b-[0.5px] border-white/25 [display:block]">
                  {column.heading}
                </span>

                <ul className="flex flex-col gap-4 list-none p-0 m-0">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <FooterLink link={link} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
